<template>
  <b-nav-item-dropdown
    right
    toggle-class="d-flex align-items-center dropdown-user-link"
    class="dropdown-user"
  >
    <template #button-content>
      <div v-if="displayName || displayRole" class="d-sm-flex d-none user-nav">
        <p class="user-name font-weight-bolder mb-0">
          {{ displayName }}
        </p>
        <span class="user-status">{{ displayRole }}</span>
      </div>

      <b-avatar
        size="40"
        :src="profileUrl"
        :text="avatarText(username)"
        badge
        class="badge-minimal"
        badge-variant="success"
      >
        <feather-icon
          v-if="!username"
          icon="UserIcon"
          size="22"
        />
      </b-avatar>
    </template>

    <!-- <b-dropdown-item
      :to="{ name: 'account-setting' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="SettingsIcon"
        class="mr-50"
      />
      <span>Settings</span>
    </b-dropdown-item> -->
    <b-dropdown-item
      link-class="d-flex align-items-center"
      @click="logout"
    >
      <feather-icon
        size="16"
        icon="LogOutIcon"
        class="mr-50"
      />
      <span>Logout</span>
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import { BNavItemDropdown, BDropdownItem, BAvatar } from 'bootstrap-vue'
import { avatarText } from '@core/utils/filter'
import { mapState, mapActions } from 'vuex'
import { initialAbility } from '@/libs/acl/config'

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BAvatar,
  },
  data() {
    return {
      avatarText,
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    currentUser() {
      return (this.user && this.user.user) || null
    },
    displayName() {
      if (!this.currentUser) return ''
      return [this.currentUser.firstName, this.currentUser.lastName].filter(Boolean).join(' ')
    },
    displayRole() {
      return (this.currentUser && this.currentUser.roles && this.currentUser.roles[0] && this.currentUser.roles[0].name) || ''
    },
    profileUrl() {
      return (this.currentUser && this.currentUser.profileUrl) || (this.user && this.user.profileUrl) || ''
    },
    username() {
      return (this.currentUser && this.currentUser.username) || (this.user && this.user.username) || ''
    },
  },
  methods: {
    ...mapActions('auth', ['purgeAuth']),

    logout() {
      this.purgeAuth()
      // Reset ability
      this.$ability.update(initialAbility)

      // Redirect to login page
      this.$router.push({ name: 'auth-login' })
    },
  },
}
</script>

<style lang="scss" scoped>
.user-status {
  text-transform: capitalize;
}
</style>
